import { useCallback, useEffect, useRef, useState } from "react";
import { Box, Container, MenuItem, Typography } from "@mui/material";
import { TypographyHead } from "./announceStyle";
import InputTextField from "../../component/input/inputTextField";
import AutocompleteSelect from "../../component/select/autoCompleteSelect";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FileRejection, useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import upload from "../../assets/images/upload.png";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonCustom from "../../component/button/buttonCustom";
import { Col, Row } from "react-bootstrap";
import Add from "../../assets/icon/addannonce.svg";
import NewsTypeApi from "../../api/setting/news/news.api";

import VisibilityIcon from "@mui/icons-material/Visibility";
import * as Style from "./announceStyle";
import DebtTypeApi from "../../api/setting/debttype/debttype.api";
import {
  notiError,
  notiSuccess,
} from "../../component/notification/notifications";
import moment from "moment";
import InputNewRangePicker from "../../component/input/InputRangePicker";
import InputCheckbox from "../../component/input/inputCheckbox";
import AnnounceApi from "../../api/home/announce.api";

import FileuploadApi from "../../api/uploadfile/upload.api";
import { useHistory, useLocation } from "react-router-dom";
import FilterSelect from "../../component/select/filterSelect";
import LeasesTypeApi from "../../api/setting/leases/leases.api";
import ZoneApi from "../../api/zone/zone.api";
import { getBranch } from "../../utils/app.utils";
import InputDatePicker from "../../component/input/inputDatePicker";
import { getApiErrorMessage, getApiErrorStatus } from "../../utils/api-error.utils";
import {
  ANNOUNCE_ACCEPT_FILE,
  ANNOUNCE_MAX_FILES,
  ANNOUNCE_MAX_FILE_SIZE,
  announceRejectMessage,
  announceSaveResultMessage,
  mergeDroppedFiles,
  syncAnnounceFiles,
} from "./components/announceFile.utils";
import AnnounceLinks, {
  AnnounceLinkItem,
  createLinkRow,
  mapAnnounceLinks,
  toLinksPayload,
  validateLinks,
} from "./components/AnnounceLinks";

const initStateErrorMessage = {
  PRFIX_NAME: ``,
  ROLDID: ``,
  NAME: ``,
  EMPLOYEE_CODE: ``,
  LASTNAME: ``,
  PHONE_NUBER: ``,
  EMAIL: ``,
  USERNAME: ``,
  PASSOWORD: ``,
  CONFIRM_PASSWORD: ``,
  BARNCH: ``,
  PW: ``,
  IDCARD: ``,
  HEAD: ``,
};

const all_id_zone = 9999999;
export default function Addannounce() {


  const history = useHistory();
  const [file, setFile] = useState<any>([]);
  const location: any = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const news_type_id = searchParams.get("type")
  const type: any = location?.state?.type
  const id: any = location?.state?.id
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
  const [newType, setNewtype] = useState<any>([]);
  const [leasesOption, setLeasesOption] = useState<any>([]);
  const [leasesTypeId, setLeasesTypeId] = useState<number>();
  const [debtType, setDebtType] = useState<any>([]);
  // แก้ชั่วคราว ต้องไล่ตั้งแต่ master 
  const [newstypeId, setNewTyperId] = useState<number>(news_type_id === 'GENERAL' ? 4 : 3);
  const [page, setPage] = useState<number>(1);
  const [discountPrice, setDiscountPrice] = useState<any>([]);
  const [select, setSelectfile] = useState<any>();
  const [title, setTitle] = useState<string>("");
  const [detail, setDetail] = useState<string>("");
  const [data, setData] = useState<any>();
  // const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const [dateStart, setDateStart] = useState<string>("");
  const [dateEnd, setDateEnd] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [checkDate, setCheckDate] = useState<boolean>(false);
  const { t } = useTranslation();
  const [zoneOption, setZoneOption] = useState<any[]>([]);
  const [searchZone, setSearchZone] = useState(all_id_zone);
  const [links, setLinks] = useState<AnnounceLinkItem[]>([createLinkRow()]);
  const [linkErrors, setLinkErrors] = useState<{ [rowId: string]: string }>({});
  /** ไฟล์เดิมที่ผู้ใช้กดถอดออก — ยังไม่ยิงลบ รอกดบันทึกก่อน ถ้าออกจากหน้าไปเลยไฟล์จะไม่ถูกลบ */
  const [deletedFiles, setDeletedFiles] = useState<any[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  /** กันกดปุ่มรัวก่อน isSubmitting จะ re-render ทัน */
  const isSubmittingRef = useRef<boolean>(false);

  const handleChangeZone = (newZone: number) => setSearchZone(newZone);

  const branchId: any = getBranch() ? Number(getBranch()) : undefined

  const zoneIdPayload =
    searchZone === all_id_zone ? null : +searchZone || null;

  /** logic อยู่ใน announceFile.utils.ts เพราะฟอร์มเช่าแผงค้าใช้ชุดเดียวกัน */
  const handleAnnounceFiles = (res: any) =>
    syncAnnounceFiles({
      res,
      files: file,
      deletedFiles,
      announceId: id,
      deleteFile: FileuploadApi.deleteFile.bind(FileuploadApi),
      uploadFiles: FileuploadApi.uploadfilearray.bind(FileuploadApi),
      errorStatus: getApiErrorStatus,
    });

  const handleSubmit = async () => {
    if (!newstypeId)
      return setErrorMessage({
        ...errorMessage,
        ...{ HEAD: t(`ANNOUNCE.NOTI.HEAD`) },
      });

    const errorLinks = validateLinks(links);
    if (Object.keys(errorLinks).length > 0) {
      setLinkErrors(errorLinks);
      return notiError(`${t("ANNOUNCE.NOTI.LINK")}`, "", null, null);
    }
    setLinkErrors({});

    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);

    const condition = {
      newstypeId: newstypeId,
      title: title,
      detail: detail,
      startDate: dateStart ? moment(dateStart).format("YYYY-MM-DD") : null,
      endDate: dateEnd ? moment(dateEnd).format("YYYY-MM-DD") : null,
      bookmark: false,
      announceType: type,
      leasesTypeId: leasesTypeId,
      // branchId:branchId,
      status: status || "PENDING",
      discountPrice: discountPrice || [],
      round: [],
      // links เป็น replace-all: ส่งทั้งชุดทุกครั้ง, [] = ลบลิงก์เดิมทั้งหมด
      links: toLinksPayload(links),
      // ส่งทั้ง 2 ชื่อ field เพราะฝั่งเขียนใช้ zoneId แต่ฝั่งอ่านกลับใช้ zoneStall
      // ยังไม่ยืนยันว่า column จริงชื่ออะไร (ดู announce-visibility-api.md)
      zoneId: zoneIdPayload,
      zoneStall: zoneIdPayload
    };

    try {
      const res = id
        ? await AnnounceApi.updateAnnounce(condition, id)
        : await AnnounceApi.createAnnounce(condition);

      if (id ? res.status !== 200 : res.status !== 201) {
        return notiError(
          id ? "บันทึกประกาศไม่สำเร็จ" : "สร้างประกาศไม่สำเร็จ",
          "",
          null,
          null
        );
      }

      // ไฟล์แนบไม่ throw แล้ว คืนสรุปผลมาให้เลือกข้อความ — record บันทึกสำเร็จไปแล้ว
      // ถ้าปล่อยให้ error ทะลุออกไป ผู้ใช้จะเข้าใจว่าบันทึกไม่สำเร็จแล้วกดซ้ำจนได้ประกาศซ้ำ
      const fileResult = await handleAnnounceFiles(res);
      // เคลียร์คิวลบ กันยิงลบซ้ำถ้าผู้ใช้กดบันทึกอีกรอบก่อนออกจากหน้า
      setDeletedFiles([]);

      const { message, warn } = announceSaveResultMessage(
        id ? `อัพเดตข้อมูลสำเร็จ` : `${t("ANNOUNCE.NOTI.SUCESS")}`,
        fileResult
      );
      if (warn) {
        // ไม่ผูก navigate กับ option "go" เพราะมันทำงานตอน toast ปิด (หน่วง 3 วิ) ผู้ใช้อาจกดไปหน้าอื่นไปแล้ว
        notiError(message, "", null, null);
        history.push("/announce");
      } else {
        notiSuccess(message, "go", "/announce", null, undefined, history);
      }
    } catch (error) {
      notiError(getApiErrorMessage(error, "บันทึกข้อมูลไม่สำเร็จ"), "", null, null);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };
  const getDeptType = async () => {
    const condition = {
      page: page,
      pageLimit: 50,
      status: "ACTIVE",
    };

    await DebtTypeApi.findAll(condition).then((res) => {
      if (res?.status === 200) {
        setDebtType(res?.data);
      }
    });
  };

  const getLeasesType = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 100,
      status: "ACTIVE"
    };
    const res = await LeasesTypeApi.findAll(condition);
    if (res.status === 200) {
      setLeasesOption(res.data);
    } else {
      setLeasesOption([])
    }

  };
  const getDetail = async () => {
    await AnnounceApi.details(id).then((res) => {
      if (res?.status === 200) {
        const data: any = res?.data

        setData(data)
        setDetail(data?.detail || '')
        setDateStart(data.startDate)
        setDateEnd(data.endDate)
        setNewTyperId(data?.newstypeId)
        setTitle(data?.title)
        setLeasesTypeId(data?.leasesTypeId)
        setDiscountPrice(data?.discountPrice)
        setFile(data?.fileUpload || []);
        const dataLinks = mapAnnounceLinks(data?.announceLinks);
        setLinks(dataLinks.length ? dataLinks : [createLinkRow()]);
        // อ่านทั้ง 2 ชื่อ field ยังไม่ยืนยันว่า column จริงชื่ออะไร (ดู announce-visibility-api.md)
        const dataZoneId = data?.zoneStall ?? data?.zoneId
        if (dataZoneId) {
          setSearchZone(dataZoneId)
        } else {
          setSearchZone(all_id_zone)
        }
        // console.log(data, 'data')
        // setSelectedDateRange([
        //   `${moment(data?.startDate)}`, `${moment(data?.endDate)}`
        // ])

        if (data.startDate && data.endDate) {
          setCheckDate(false)
        } else {
          setCheckDate(true)
        }

        setStatus(data?.status)

      }
    });
  }
  useEffect(() => {
    if (id) {
      getDetail()
    }
    getLeasesType()
    getDeptType();
  }, []);
  const addDiscount = () => {
    const row = {
      paymentServiceId: null,
      rowId: Math.floor(3 * discountPrice.length),
      amount: null,
      status: "ACTIVE",
    };
    setDiscountPrice([...discountPrice, row]);
  };
  const handlepreview = (x: any) => {
    if (x?.filePath && x?.fileName) {
      if (x.mimetype === "application/pdf") {
        window.open(process.env.REACT_APP_FILE_URL +
          x?.filePath +
          x?.fileName, "_blank");
      } else {
        setSelectfile(process.env.REACT_APP_FILE_URL +
          x?.filePath +
          x?.fileName);
      }
    } else {
      const name = x.type.split(".");

      if (name[name?.length - 1] === "application/pdf") {
        window.open(URL.createObjectURL(x), "_blank");
      } else {
        setSelectfile(URL.createObjectURL(x));
      }
    }

  };

  // const handleRangeDate = (value: any) => {
  //   // setSelectedDateRange(value);
  //   setDateStart(moment(value[0]).format("YYYY-MM-DD"));
  //   setDateEnd(moment(value[1]).format("YYYY-MM-DD"));
  // };
  /**
   * ถอดไฟล์ออกจากฟอร์มเท่านั้น ยังไม่ยิงลบ — ไฟล์ที่บันทึกไว้แล้ว (มี fileId) เข้าคิวไว้
   * รอกดบันทึกจึงลบจริง ถ้าผู้ใช้ออกจากหน้าไปเลยไฟล์ยังอยู่ครบ
   *
   * ลบด้วย index ไม่ใช่ path — record จาก DB ไม่มี field path ในโหมดแก้ไขจึงเป็น
   * undefined !== undefined ทุกตัว = ลบ 1 ไฟล์แล้วลิสต์หายทั้งหมด
   */
  const handledelete = (x: any, index: number) => {
    if (x?.fileId) setDeletedFiles((prev: any[]) => [...prev, x]);
    setFile(file.filter((_: any, i: number) => i !== index));
    setSelectfile(null);
  };
  const deletediscount = (rowId: any) => {
    const newData = discountPrice.filter((x: any) => x.rowId !== rowId);
    setDiscountPrice(newData);
  };

  const getnewType = async () => {
    const codition = {
      page: 1,
      pageLimit: 50,
      announceType: type,
    };
    await NewsTypeApi.findAll(codition).then((res) => {
      if (res.status === 200) {
        setNewtype(res?.data);
      }
    });
  };
  // const handleClearRangeDate = () => {
  //   // setSelectedDateRange([]);
  //   setDateStart("");
  //   setDateEnd("");
  // };
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (!acceptedFiles?.length) return;
      const { files, duplicated, overflow } = mergeDroppedFiles(file, acceptedFiles);
      if (duplicated) notiError("ไฟล์นี้ถูกแนบไว้แล้ว", "", null, null);
      if (overflow)
        notiError(`แนบไฟล์ได้ไม่เกิน ${ANNOUNCE_MAX_FILES} ไฟล์`, "", null, null);
      setFile(files);
    },
    [file]
  );

  const onDropRejected = useCallback((rejections: FileRejection[]) => {
    notiError(announceRejectMessage(rejections), "", null, null);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDropRejected,
    accept: ANNOUNCE_ACCEPT_FILE,
    multiple: true,
    maxSize: ANNOUNCE_MAX_FILE_SIZE,
  });

  useEffect(() => {
    getnewType();
  }, []);

  function getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader: any = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };

      reader.onerror = (error: any) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  const uploadAdapter = (loader: any) => {
    return {
      upload: async () => {
        const file = await loader.file;
        const base64 = await getBase64(file);
        const blob = new Blob([file], { type: 'image/svg+xml' });
        const url = URL.createObjectURL(blob);

        return {
          default: "data:image/jpeg;base64," + base64,
          // default: url.split("blob,:")
        };
      },
    };
  };

  function uploadPlugin(editor: any) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
      return uploadAdapter(loader);
    };
  }

  useEffect(() => {
    getLeasesType();
  }, []);

  const getZone = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 100,
      status: "CONTRACT",
      skipcalculation: 0,
      branchId: branchId
    };
    const res = await ZoneApi.list(condition)

    if (res.status === 200) {
      setZoneOption(res.data);
    } else {
      setZoneOption([])
    }
  };

  useEffect(() => {
    getZone();

  }, []);

  const zone_data: any[] = zoneOption?.length > 0 ? [{ zoneName: "ทั้งหมด", zoneId: all_id_zone }, ...zoneOption] : []
  // console.log(zone_data,'zone_data')

  // console.log(searchZone, 'searchZone')
  // console.log(zoneOption.find((e) => e.zoneId == +searchZone), 'zoneOption.find((e) => e.zoneId == searchZone)')

  return (
    <Box>
      <Style.headerannoce>
        <TypographyHead>{type === 'HELP' ? t("ANNOUNCE.HEAD.ADDANNOUNCEHELP") : 'ประกาศข่าวสารจากระบบ'}</TypographyHead>
      </Style.headerannoce>
      <Style.boxcontainer>
        <Style.boxinsite>
          <Style.boxinsitebackground>
            <Container maxWidth="lg">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Row>
                  <Col item lg={2} xs={12} className="my-1">
                    {t("ANNOUNCE.CREATE.NEW_TYPE")}
                  </Col>
                  <Col item lg={10} xs={12} className="my-1">
                    {/* <AutocompleteSelect
                      options={newType}
                      required={true}
                      value={
                        newstypeId
                          ? newType.find(
                              (data: any) => data.newstypeId === newstypeId
                            )
                          : null
                      }
                      getOptionLabel={(option: any) => option.newstypeNameTh}
                      // onChange={(data: any) => setPrefixId(data.value)}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setNewTyperId(newValue.newstypeId);
                        }
                      }}
                      helperText={errorMessage.HEAD}
                      labelId="add"
                    /> */}
                    {type === 'HELP' ? 'ประกาศมาตรการช่วยเหลือ' : 'ประกาศข่าวสารจากระบบ'}
                  </Col>
                  <Col lg={2} xs={12} className="my-1">
                    {t("ANNOUNCE.CREATE.HEAD")}
                  </Col>
                  <Col lg={10} xs={12} className="my-1">
                    <InputTextField value={title}
                      onchange={(e) => setTitle(e.target.value)}
                    />
                  </Col>
                  {/* <Col lg={2} xs={12} className="my-1">
                    {t("ประเภทลูกค้า")}
                  </Col>
                  <Col lg={10} xs={12} className="my-1">
                    <FilterSelect
                      onchange={(e: any) => {
                        setLeasesTypeId(e.target.value)

                      }}
                      options={leasesOption && leasesOption.map((e: any) => {
                        return <MenuItem value={e.leasesTypeId} >{e.leasesTypeNameTh || e.leasesTypeNameEn}</MenuItem>;
                      })}
                      selectId="select-user-type"
                      value={leasesTypeId || ''}
                      labelId=""
                    // renderValue={() =>
                    //   `${t("PAYBILL.INPUT.DEPT")}: `
                    // }
                    />
                  </Col> */}
                  <Col lg={2} xs={12} className="my-1">
                    {t("ANNOUNCE.CREATE.DETAILCREATE")}
                  </Col>
                  <Col lg={10} xs={12} className="my-1">
                    <div style={{ width: "100%" }}>
                      <CKEditor
                        editor={ClassicEditor}
                        onReady={(editor) => {
                        }}
                        config={{
                          extraPlugins: [uploadPlugin],
                          toolbar: {
                            items: [
                              'heading',
                              '|',
                              'bold',
                              'italic',
                              '|',
                              'bulletedList',
                              'numberedList',
                              '|',
                              'insertTable',
                              '|',
                              'imageUpload',
                              '|',
                              'undo',
                              'redo'
                            ]
                          },
                        }}
                        data={detail}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDetail(data);
                        }}
                      />
                    </div>
                  </Col>
                  {/* พี่อ้ายให้เอากลับมา ถูก comment ไปหลายเดือนแล้ว */}
                  {/* {type === 'HELP' && <>
                    <Col lg={2} xs={12} className="my-2">
                      {t("ANNOUNCE.CREATE.DISCOUNT")}
                    </Col>
                    <Col lg={10} xs={12} className="my-2">
                      <Box sx={{ backgroundColor: "#E8EBF0", padding: "8px" }}>
                        <Container>
                          <Box
                            sx={{
                              width: "100%",
                              backgroundColor: "#E8EBF0",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box>
                              <Typography>
                                {t("ANNOUNCE.CREATE.DISCOUNT")}
                              </Typography>
                            </Box>
                            <Box onClick={addDiscount} sx={{ cursor: "pointer" }}>
                              <img src={Add} />
                            </Box>
                          </Box>
                        </Container>
                      </Box>
                      <Box>
                        {discountPrice.map((obj: any, index: any) => (
                          <Row
                            key={index}
                            className="my-3"
                            style={{ alignItems: "center" }}
                          >
                            <Col lg={2} className="my-3">
                              <Typography>
                                {index + 1} {t("ANNOUNCE.CREATE.DETAIL")}
                              </Typography>
                            </Col>
                            <Col lg={4} className="my-3">
                              <AutocompleteSelect
                                options={debtType}
                                value={
                                  debtType?.find(
                                    (item: any) =>
                                      item.paymentServiceId === obj.paymentServiceId
                                  ) || null
                                }
                                getOptionLabel={(option: any) =>
                                  option.paymentName
                                }
                                onChange={(data: any, newValue) => {
                                  const newData = discountPrice?.map(
                                    (item: any) => {
                                      if (item.rowId === obj.rowId) {
                                        return {
                                          ...item,
                                          paymentServiceId:
                                            newValue?.paymentServiceId || newValue,
                                        };
                                      }
                                      return item;
                                    }
                                  );
                                  setDiscountPrice(newData);
                                }}
                                labelId="add"
                              />
                            </Col>
                            <Col lg={4} className="my-3">
                              <InputTextField
                                onkeypress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={obj?.amount}
                                onchange={(e) => {
                                  const newData = discountPrice?.map(
                                    (item: any) => {
                                      if (item.rowId === obj.rowId) {
                                        return {
                                          ...item,
                                          amount: parseInt(e.target.value),
                                        };
                                      }
                                      return item;
                                    }
                                  );
                                  setDiscountPrice(newData);
                                }}
                              />
                            </Col>

                            <Col lg={1} className="my-3">
                              <Typography sx={{ whiteSpace: "nowrap" }}>{t("ร้อยละ %")}</Typography>
                            </Col>
                            <Col lg={1} className="my-3">
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <DeleteIcon
                                  onClick={(e) => deletediscount(obj.rowId)}
                                  color="error"
                                  sx={{ cursor: "pointer" }}
                                />
                              </Box>
                            </Col>
                          </Row>
                        ))}

                        <Box></Box>
                      </Box>
                    </Col></>} */}
                  <Col lg={2} xs={12} className="my-1">
                    {t("ANNOUNCE.CREATE.FILE")}
                  </Col>
                  <Col lg={10} xs={12} className="my-1">
                    <Style.boxupload>
                      {" "}
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        {select ? (
                          <>
                            <img
                              src={select}
                              alt="Thumb"
                              style={{ height: "250px", cursor: "pointer" }}
                            />
                          </>
                        ) : (

                          <img src={upload} style={{ width: "100%", cursor: "pointer" }} />

                        )}
                      </div>
                    </Style.boxupload>
                  </Col>

                  {file?.map((e: any, index: any) => (
                    <>
                      <Col item lg={1} xs={12}></Col>
                      <Col item lg={1} xs={12} className="my-2 d-flex justify-content-center align-items-center">
                        {index + 1}
                      </Col>
                      <Col item lg={10} xs={12} className="my-2">
                        <Style.filearray>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box>{e.fileName || e.name}</Box>
                            <Box>
                              <VisibilityIcon
                                onClick={() => handlepreview(e)}
                                sx={{ cursor: "pointer", marginRight: "10px" }}
                              />
                              <DeleteIcon
                                onClick={() => handledelete(e, index)}
                                color="error"
                                sx={{ cursor: "pointer" }}
                              />
                            </Box>
                          </Box>
                        </Style.filearray>
                      </Col>
                    </>
                  ))}

                  {(type === 'HELP') && (
                    <>
                      <Col lg={2} xs={12} style={{ display: "flex", gap: 1, justifyContent: "start", alignItems: 'center' }} className="my-1">
                        {t("PAYBILL.INPUT.SEARCH_ZONE")} <Typography sx={{ color: 'red' }} ml={1}>*</Typography>
                      </Col>

                      <Col lg={10} md={12} xs={12} className="my-1">
                        <AutocompleteSelect
                          placeholder="ระบุโซน"
                          required={true}
                          options={zone_data}
                          value={zone_data.find((e) => e.zoneId == searchZone) || null}
                          getOptionLabel={(option: any) => option.zoneName}
                          onChange={(_: any, val: any) => {
                            handleChangeZone(val?.zoneId)
                            setPage(1)
                          }}
                          labelId="zone-name"
                        />
                      </Col>
                    </>
                  )}

                  <Col lg={2} xs={12} className="my-1">
                    {t("ANNOUNCE.CREATE.LINK")}
                  </Col>
                  <Col lg={10} xs={12} className="my-1">
                    <AnnounceLinks
                      links={links}
                      onChange={setLinks}
                      errors={linkErrors}
                    />
                  </Col>

                  <Col item xs={2}></Col>
                  <Col item lg={10} xs={12} className="my-2">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <InputCheckbox
                        style={{ marginLeft: "10px" }}
                        checked={checkDate}
                        onChange={(e) => {
                          setCheckDate(e.target.checked);
                          if (e.target.checked) {
                            const oneHundredYearAgo = moment().add(100, 'year').format("YYYY-MM-DD");
                            setDateEnd(oneHundredYearAgo)
                          }
                        }}
                      />

                      {t("ANNOUNCE.CREATE.NO_TIME")}
                    </Box>
                  </Col>
                  <Col item lg={2} xs={12} className="my-2">
                    {t("ANNOUNCE.CREATE.DATE_TIME")}
                  </Col>
                  <Col item lg={4} xs={12} className="my-2">
                    <InputDatePicker
                      required={true}
                      onChange={(e) => setDateStart(moment(e).format("YYYY-MM-DD"))}
                      value={dateStart || ""}
                      placeholder="ระบุวันที่เริ่มต้น"
                      heading="วันที่เริ่มต้น"
                    />
                    {/* <InputNewRangePicker
                      key={"date-appointment"}
                      label={t("REPAIR_TYPE_MANGEMENT.INPUT.START_END_DATE")}
                      value={selectedDateRange}
                      onClear={handleClearRangeDate}
                      onchange={handleRangeDate}
                      disabled={checkDate}

                    /> */}
                  </Col>
                  <Col item lg={4} xs={12} className="my-2">
                    <InputDatePicker
                      required={true}
                      onChange={(e) => setDateEnd(moment(e).format("YYYY-MM-DD"))}
                      value={dateEnd || ""}
                      disabled={checkDate || !dateStart}
                      disableStartDate={dateStart}
                      placeholder="ระบุวันที่สิ้นสุด"
                      heading="วันที่สิ้นสุด"
                    />
                  </Col>
                  <Col item lg={12} xs={12}>
                    <ButtonCustom
                      type="submit"
                      onClick={handleSubmit}
                      disabled={type === 'HELP' ? (!dateStart || !dateEnd || !searchZone) : (!dateStart || !dateEnd)}
                      loading={isSubmitting}
                      loadingText="กำลังบันทึก..."
                      textButton={t("REGISTER.BUTTON.SUMMIT")}
                      btnStyle={{
                        fontSize: "16px",
                        width: "100%",
                        padding: "0px",
                        marginTop: "32px",
                        marginBottom: "14px",
                      }}
                    />
                  </Col>
                </Row>
              </Box>
            </Container>
          </Style.boxinsitebackground>
        </Style.boxinsite>
      </Style.boxcontainer>
    </Box>
  );
}
